import {ScribbleData} from '@docma-mm-core/scribble/scribble';
import {ArrowAnnotation, Size} from '@mydocma/component-library/src/lib/annotation';
import {PinStyleEnum} from '@docma-mm-core/scribble/pin-style.enum';
import {toARGB, toRGB} from './converter';

export class ArrowConverter {

  /* COMPONENT MODEL TO SCRIBBLE */
  static convertToData(anno: ArrowAnnotation, containerSize: Size): ScribbleData {
    const points = anno.points;
    const xs = points.filter((_, i) => i % 2 === 0);
    const ys = points.filter((_, i) => i % 2 === 1);
    const strokeWidth = anno.style?.stroke?.width ?? 3;
    const halfStroke = strokeWidth / 2;
    const minX = Math.min(...xs);
    const maxX = Math.max(...xs);
    const minY = Math.min(...ys);
    const maxY = Math.max(...ys);
    const adjustedMinX = minX - halfStroke;
    const adjustedMaxX = maxX + halfStroke;
    const adjustedMinY = minY - halfStroke;
    const adjustedMaxY = maxY + halfStroke;

    const width = adjustedMaxX - adjustedMinX;
    const height = adjustedMaxY - adjustedMinY;

    const shiftedPoints: number[] = [];
    for (let i = 0; i < points.length; i += 2) {
      shiftedPoints.push(points[i] - adjustedMinX);
      shiftedPoints.push(points[i + 1] - adjustedMinY);
    }

    const stageWidth = containerSize.width;
    const stageHeight = containerSize.height;

    const relX = adjustedMinX / stageWidth;
    const relY = adjustedMinY / stageHeight;
    const relW = width / stageWidth;
    const relH = height / stageHeight;

    return {
      UniqueId: anno.id,
      RelativeBasePointToParentPositionX: relX,
      RelativeBasePointToParentPositionY: relY,
      RelativeScaleX: relW,
      RelativeScaleY: relH,

      RelativeAnchorToParentPositionX: 0,
      RelativeAnchorToParentPositionY: 0,
      RelativeAnchorToCanvasPositionX: 0,
      RelativeAnchorToCanvasPositionY: 0,

      ScribblePath: shiftedPoints.join(','),
      PinShape: anno.type,

      PinStyle: PinStyleEnum.Form,

      BorderColorValue: toARGB(anno.style?.stroke?.color ?? '#0000FFFF', anno.style?.stroke?.opacity),
      BorderWidth: anno.style?.stroke?.width ?? 3,
      FillColorValue: '#FFFFFF00'
    } as ScribbleData;
  }

  /* SCRIBBLE TO COMPONENT MODEL */
  static convertToModel(scribble: ScribbleData, container: Size): ArrowAnnotation {
    const anno = {
      type: scribble.PinShape,
      id: scribble.UniqueId,
      points: [],
      style: {
        stroke: {
          color: toRGB(scribble.BorderColorValue),
          width: scribble.BorderWidth ?? 3,
          opacity: 1
        }
      }

    } as ArrowAnnotation;
    if (scribble.ScribblePath) {

      const width = (scribble.RelativeScaleX || 0) * container.width;
      const left = container.width * scribble.RelativeBasePointToParentPositionX - (scribble.RelativeAnchorToCanvasPositionX || 0) * width;
      const height = (scribble.RelativeScaleY || 0) * container.height;
      const top = container.height * scribble.RelativeBasePointToParentPositionY - (scribble.RelativeAnchorToCanvasPositionY || 0) * height;
      const points: number[] = scribble.ScribblePath.split(/[\s,]+/).map((p, i) => {
        if (i % 2) {
          return top + Number(p);
        } else {
          return left + Number(p);
        }
      });
      anno.points = points;
    }
    return anno;
  }
}
